
import React, { useEffect, useState } from 'react';
import { cmsDetailsAction } from '../../../features/webCommonSlice';
import moment from 'moment';
import CmsPageShimmer from '../CmsPageShimmer/CmsPageShimmer';

const RefundsAndCancellations = () => {
    const [loader, setLoader] = useState(false)
    const [cmsDetails, setCmsDetails] = useState({});

    useEffect(() => {
        setLoader(true)
        cmsDetailsAction({ slug: "refund-cancellation" }, (response) => {
            if (response?.status === true) {
                setCmsDetails(response?.data)
            }
            setLoader(false)
        })();
    }, [cmsDetailsAction])

    return (
        <>
            <div className='cms_landing_page'>
                <div className='banner'>
                    Refund & Cancellation
                    {/* {cmsDetails.title} */}
                    {/* {cmsDetails?.updatedAt ? moment(cmsDetails.updatedAt).format("YYYY-MM-DD") : "-"} */}
                </div>
                <div className='container'>
                    {/* {!loader ?
                        <div className='cms_content_text'>
                            <div dangerouslySetInnerHTML={{ __html: cmsDetails.description }}></div>
                        </div>
                        :
                        <>
                            <CmsPageShimmer />
                        </>
                    } */}
                    <div className="cms_content_text">
                        <p>a) In the event, that there is an error in the Services provided by us, we may refund the Entry Fee, provided the reasons are genuine and proved after investigation by Millionaire11.</p>
                        <p>b) Please read the rules of each Game and Contest before participating.</p>
                        
                        <br />

                        <h2>Cancellation Policy</h2>
                        <p>a) We do not cancel registrations once entered. However, in exceptional circumstances where the fault lies with the payment gateway or on our side, we will cancel your participation upon request and refund the Entry Fee within a reasonable amount of time.</p>
                        <p>b) In case we cancel your participation in any Game or Contest due to such reasons, we will return your Entry Fee within a reasonable amount of time for you to redeem it by participating in other contests on Millionaire11.</p>
                        <p>c) If you are not fully satisfied with any deposit/purchase made or fee paid on Millionaire11 and believe there has been an error in the transaction, please notify us within 3 days from the transaction date. We will review and determine a resolution at our sole discretion.</p>
                        
                        <br />

                        <h2>Refund Policy</h2>
                        
                        <p>a) We strive to provide the best user experience. If payment was made via credit card, any refund will be issued to the original credit card used. For payments made through a payment gateway, refunds will be processed to the same account.</p>
                        <p>b) All deposits, purchases, and fees paid on Millionaire11 are final. All transactions are considered final. Only transactions involving errors will be reviewed for refund eligibility.</p>
                        <p>c) Once a refund request is approved, the refunded amount will be processed and credited within 2 days to the original mode of payment.</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RefundsAndCancellations